

import barba from '@barba/core';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import LocomotiveScroll from "locomotive-scroll";


export default class{

	constructor(){

        this.isInit = false
		this.initY = 0
        this.triggerIndexFeatures = false
        this.triggerIndexProductPrimary = false
        this.triggerIndexProductSecondary = false

        window.historyScrollPosition = []
        
        barba.hooks.once((data) => {
            this.run(document.querySelector("[data-scroll-container]"))
        })

        barba.hooks.afterOnce((data) => {
            this.refresh()
            this.init()
        })

        barba.hooks.beforeLeave((data) => {
            if(data.trigger == "back" || data.trigger == "forward"){
                if(window.historyScrollPosition.length > 0){
                    this.initY = window.historyScrollPosition.pop()
                }
            }
            window.historyScrollPosition.push(window.LocomotiveScroll.scroll.instance.scroll.y)
            
        })

        barba.hooks.leave((data) => {
            window.LocomotiveScroll.destroy()
        })
        
        barba.hooks.afterEnter((data) => {
           
            if(this.isInit){
                this.run(data.next.container.querySelector("[data-scroll-container]"))
                this.refresh()
            }
            if(!this.isInit){
                this.isInit = true
            }
        })

        barba.hooks.after((data) => {
           
            if(data.trigger==='back' || data.trigger==='forward'){
                const sections = document.querySelectorAll('[data-scroll-trigger]')
                if( sections.length > 0 ){
                    sections.forEach( el => { 
                        el.classList.add('-visible')
                    })
                }
                
            }else{
                this.initY = 0
                this.init()
            }
            setTimeout(() => {
                this.refresh()
            }, 1);
        });
    }
    
    run(el){
        gsap.registerPlugin(ScrollTrigger);

        // Using Locomotive Scroll from Locomotive https://github.com/locomotivemtl/locomotive-scroll

        window.LocomotiveScroll = new LocomotiveScroll({
            el: el,
            smooth: true,
            lerp:.25,
            multiplier:.6,
            initPosition :{
                x: 0,
                y: this.initY
            }
        });
        
        // each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
        window.LocomotiveScroll.on("scroll", ScrollTrigger.update);

        // tell ScrollTrigger to use these proxy methods for the "[data-scroll-container]" element since Locomotive Scroll is hijacking things
        ScrollTrigger.scrollerProxy("[data-scroll-container]", {
            scrollTop(value) {
                return arguments.length ? window.LocomotiveScroll.scrollTo(value, 0, 0) : window.LocomotiveScroll.scroll.instance.scroll.y;
            }, // we don't have to define a scrollLeft because we're only scrolling vertically.
            getBoundingClientRect() {
                return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
            },
            // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
            pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
        });


        const header = document.querySelector("#l-header")

        const about = el.querySelector("#p-about")
        if(about){
            gsap.to(
                "#p-about .p-about__scroller",
                {
                    x:"-500%",
                    scrollTrigger: {
                        trigger: "#p-about .p-about__scroller",
                        scroller: "[data-scroll-container]",
                        start: 'top top',
                        end: '800%',
                        pin:true,
                        scrub:true,
                        onEnter :() => {
                            header.classList.add("-in-white")
                        },
                        onEnterBack:() => {
                            header.classList.add("-in-white")
                        },
                        onLeave:() => {
                            header.classList.remove("-in-white")
                        },
                        onLeaveBack:() => {
                            header.classList.remove("-in-white")
                        },
                    }
                }
            );
            }else{
            const triggers = el.querySelectorAll('[data-header-toggle]')
            if(triggers.length > 0){
                triggers.forEach((el) => {
                    ScrollTrigger.create({
                        trigger: el,
                        scroller: "[data-scroll-container]",
                        start: 'top-=60 top',
                        end: 'bottom top',
                        onEnter :() => {
                            header.classList.add("-in-white")
                        },
                        onEnterBack:() => {
                            header.classList.add("-in-white")
                        },
                        onLeave:() => {
                            header.classList.remove("-in-white")
                        },
                        onLeaveBack:() => {
                            header.classList.remove("-in-white")
                        },
                    });
                })
            }
            ScrollTrigger.create({
                trigger:el.querySelector("[data-footer-trigger]"),
                scroller: "[data-scroll-container]",
                start: 'top top',
                end: 'bottom top',
                onEnter :() => {
                    header.classList.add("-in-footer")
                },
                onEnterBack:() => {
                    header.classList.add("-in-footer")
                },
                onLeave:() => {
                    header.classList.remove("-in-footer")
                },
                onLeaveBack:() => {
                    header.classList.remove("-in-footer")
                },
            });
        }
        const side = el.querySelector("[data-stickey-side]")
        if(side){
            ScrollTrigger.create({
                trigger:el.querySelector("[data-stickey-container]") ,
                scroller: "[data-scroll-container]",
                start: 'top 90px',
                end: 'bottom top+=' + side.clientHeight,
                pin: side
            });
        }
       
        // this.curve(el)
        // ScrollTrigger.matchMedia({
	
        //     "(min-width:992px)": () => {
            
               
        //     }
        // })

        // // --- RED PANEL ---
        // gsap.from(".line-1", {
        //     scrollTrigger: {
        //         trigger: ".line-1",
        //         scroller: "[data-scroll-container]",
        //         scrub: true,
        //         start: "top bottom",
        //         end: "top top",
        //         onUpdate: self => console.log(self.direction)
        //     },
        //     scaleX: 0,
        //     transformOrigin: "left center", 
        //     ease: "none"
        // });


        // // --- ORANGE PANEL ---
        // gsap.from(".line-2", {
        //     scrollTrigger: {
        //         trigger: ".orange",
        //         scroller: "[data-scroll-container]",
        //         scrub: true,
        //         pin: true,
        //         start: "top top",
        //         end: "+=100%"
        //     },
        //     scaleX: 0, 
        //     transformOrigin: "left center", 
        //     ease: "none"
        // });


        // var tl = gsap.timeline({
        //     scrollTrigger: {
        //     trigger: ".purple",
        //     scroller: "[data-scroll-container]",
        //     scrub: true,
        //     pin: true,
        //     start: "top top",
        //     end: "+=100%"
        //     }
        // });

        // tl.from(".purple p", {scale: 0.3, rotation:45, autoAlpha: 0, ease: "power2"})
        // .from(".line-3", {scaleX: 0, transformOrigin: "left center", ease: "none"}, 0)
        // .to(".purple", {backgroundColor: "#28a92b"}, 0);
    }
    
    refresh(){
       
        ScrollTrigger.addEventListener("refresh", () => {
            window.LocomotiveScroll.update()
        });
        ScrollTrigger.refresh();
    }
    init(){
        const callback = (entries) => {
            entries.forEach( (entry) => {
                
                if (entry.isIntersecting) {
                    visible(entry.target);
                }
            });
        }
        const observerOptions = {
            rootMargin: "0px 0px -20% 0px",
            threshold: 0
        }
        this.observer = new IntersectionObserver(callback, observerOptions)
        const sections = document.querySelectorAll('[data-scroll-trigger]')
        if( sections.length > 0 ){
            sections.forEach( el => { 
                this.observer.observe(el)
            })
        }

        // const strAnimations = document.querySelectorAll('[data-scroll-trigger="translateY"]')
        // if(strAnimations.length > 0 ){
        //     strAnimations.forEach((el) => {
        //         let _str = el.textContent.split("");
        //         let str = "";
        //         _str.map( s => {
        //             str += "<span class='str__animation'>" + s  + "</span>";
        //         })
                    
        //         el.innerHTML = str;
        //     })
        // }

        const visible = (t) => {
            const triggerType = t.getAttribute('data-scroll-trigger')
            if(!t.classList.contains('-visible')){

                if(triggerType == 'translateY'){
                    const strs = t.querySelectorAll('.str__animation');

                    anime({
                        targets: strs,
                        translateY:['100%',0],
                        easing: 'easeInOutSine',
                        duration: 800,
                        delay: function(el, i) { return i * 20 },
                        complete :()=>{
                            t.classList.add('-visible')
                        }
                    });
                }else{
                    t.classList.add('-visible')
                }
            }

        }
    }

    curve(container){
        const els = container.querySelectorAll(".c-curve")
        if (els.length > 0) {
            els.forEach(el => {
                // this.curvesEl.push(
                    gsap.to(
                        el,
                        {
                            height:"0px",
                            scrollTrigger: {
                                trigger: el.parentElement,
                                scroller: "[data-scroll-container]",
                                start: 'top center',
                                end: 'bottom top',
                                scrub:true
                                // pin:el
                            }
                        }
                    ) 
                // )
            })
        }
    }

}